import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _MacroProcess } from '../../../../core/services/dataBean/EntityCatalog';
import { _BudgetTypes } from '../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnList?: any;
}

export const SelectBudgetTypes = ({ idSelector, onChange, label, returnList }: Props) => {

    const budgetTypes = useDataBean(_BudgetTypes)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {

        budgetTypes.instance.getBudgetTypes(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                    if (returnList)
                        returnList(resp);

                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo Concepto:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }

            </select>
        </>
    )
}